// extracted by mini-css-extract-plugin
export var acitonButtons = "_mg-0";
export var additionalIcon = "_mg-f";
export var block = "_mg-1";
export var blockContent = "_mg-7";
export var blockDescription = "_mg-8";
export var blockIcon = "_mg-9";
export var blockTitle = "_mg-6";
export var border = "_mg-a";
export var center = "_mg-l";
export var edge = "_mg-b";
export var edgeLabel = "_mg-c";
export var edgePath = "_mg-d";
export var error = "_mg-e";
export var flowchart = "_mg-g";
export var flowchartContent = "_mg-h";
export var highlighted = "_mg-3";
export var hover = "_mg-4";
export var icon = "_mg-i";
export var left = "_mg-m";
export var navButton = "_mg-j";
export var navButtons = "_mg-k";
export var right = "_mg-n";
export var selected = "_mg-2";
export var small = "_mg-5";